import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n/i18n'
import store from './store/store'
import './registerServiceWorker'
import firebase from 'firebase/app'
import checkView from 'vue-check-view'
import PinchZoom from 'vue-pinch-zoom'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

Vue.use(checkView)
Vue.component('pinch-zoom', PinchZoom)

Vue.config.productionTip = false

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABSER_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
}

firebase.initializeApp(config)

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
